import React from 'react';

function Spinner() {
    return <span className="loading loading-spinner loading-xs"></span>
    // return (
    //     <div className="flex items-center justify-center min-h-screen bg-gray-100">
    //         <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
    //     </div>
    // );
}

export default Spinner;
